/* REFONTE 2026
 * Ancien gestionnaire global volontairement neutralisé.
 * La logique sur-mesure active est portée par snippets/sur-mesure-asset.liquid.
 * Ne pas réactiver ce fichier : deux gestionnaires provoquent un double ajout panier.
 */
window.__lmdrLegacySurMesureDisabled = true;
